import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = () => {
  const orgJSONLD = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "M2HSE Training",
    alternateName: "M2HSE",
    url: "https://m2hse.co.uk/",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDPj_GGmVNKL-7-8vcxfJB8m6EZ_gKcc41Xw&s",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "02080599944",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "GB",
      availableLanguage: "en",
    },
    sameAs: [
      "https://www.instagram.com/m2hsetraining/",
      "https://www.linkedin.com/company/m2hse-training/",
    ],
  };

  const websiteJSONLD = {
    "@context": "https://schema.org/",
    "@type": "WebSite",
    name: "M2HSE Training",
    url: "https://m2hse.co.uk/",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://m2hse.co.uk/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const localBusinessJSONLD = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "M2HSE Training",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDPj_GGmVNKL-7-8vcxfJB8m6EZ_gKcc41Xw&s",
    "@id": "",
    url: "https://m2hse.co.uk",
    telephone: "02080599944",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "M2HSE Training Ltd, Ceme Business Campus, Commercial 1, Marsh Way,",
      addressLocality: "Rainham",
      postalCode: "RM13 8EU",
      addressCountry: "GB",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 51.517699,
      longitude: 0.1718641,
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "07:00",
      closes: "17:00",
    },
    sameAs: [
      "https://www.linkedin.com/company/m2hse-training/",
      "https://www.instagram.com/m2hsetraining/",
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(orgJSONLD)}</script>
      <script type="application/ld+json">
        {JSON.stringify(websiteJSONLD)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessJSONLD)}
      </script>
    </Helmet>
  );
};

export default SEO;
